import { RatioCalculator } from "modules/RatioCalculator";
export default RatioCalculator;
